// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1t2yv","content":"styles_content__19ynP"};